import type { Language } from "prism-react-renderer";
import { useState } from "react";
import Highlight, { defaultProps, Prism } from "prism-react-renderer";
import { styled } from "@linaria/react";
import CopyCode from "./CopyCode";
import fiberTheme from "./fiberTheme"; // Looks like an awful hack - and in fairness, it is - recommended via the docs:
// https://github.com/FormidableLabs/prism-react-renderer#faq
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

(typeof global !== "undefined" ? global : window).Prism = Prism;

require("prismjs/components/prism-rust");

type CodeProps = {
  className: string;
  children: string;
};
const HighlightWrapper = /*#__PURE__*/styled("div")({
  name: "HighlightWrapper",
  class: "h1clg9jn"
});
const LanguageDisplayName = /*#__PURE__*/styled("span")({
  name: "LanguageDisplayName",
  class: "l1om2j2j"
});
const CodeSnippet = /*#__PURE__*/styled("pre")({
  name: "CodeSnippet",
  class: "c1pcq445"
});

const getLanguageDisplayName = (language: Language | "rust"): string => {
  switch (language) {
    case "tsx" || "typescript":
      return "TypeScript";

    case "rust":
      return "Rust";

    default:
      return `${language[0].toUpperCase()}${language.slice(1)}`;
  }
};

const Code = ({
  className,
  children
}: CodeProps): JSX.Element => {
  const [hovered, setHovered] = useState<boolean>(); // TODO (Oscar): validate the language here, otherwise set to a fallback
  // language - default to Bash

  const language = (className.split("language-")[1] as Language);
  const codeSnippet = children.trim();
  const languageDisplayName = getLanguageDisplayName(language);
  return <HighlightWrapper onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <LanguageDisplayName>{languageDisplayName}</LanguageDisplayName>
      <Highlight {...defaultProps} code={codeSnippet} language={language} Prism={Prism} theme={fiberTheme}>
        {({
        className,
        style,
        tokens,
        getLineProps,
        getTokenProps
      }) => <CodeSnippet className={className} style={style}>
            {tokens.map((line, i) => <div key={i} {...getLineProps({
          line,
          key: i
        })}>
                {line.map((token, key) => <span key={key} {...getTokenProps({
            token,
            key
          })} />)}
              </div>)}
          </CodeSnippet>}
      </Highlight>
      <CopyCode codeSnippet={codeSnippet} hovered={hovered} />
    </HighlightWrapper>;
};

export default Code;

require("../../../.linaria-cache/src/components/Code/index.linaria.module.css");